import { Button } from "antd";
import { ReactNode } from "react";
import AddIcon from "../../assets/icons/AddIcon";
import AlertRedIcon from "../../assets/icons/AlertRedIcon";
import AlertYellowIcon from "../../assets/icons/AlertYellowIcon";
import DeleteIcon from "../../assets/icons/DeleteIcon";
import EditIcon from "../../assets/icons/EditIcon";
import RefreshIcon from "../../assets/icons/RefreshIcon";
import SuccessGreenIcon from "../../assets/icons/SuccessGreenIcon";
import { cn } from "../../utils/string";
import CustomModal from "./CustomModal";

export interface Props {
  open: boolean;
  actionButton?: boolean;
  actionBtnText?: string;
  actionBtnIcon?: boolean;
  actionBtnIconType?: "delete" | "update" | "create" | "refresh";
  actionBtnType?: "danger-light" | "primary-light" | "bordered-light";
  cancelButton?: boolean;
  cancelText?: string;
  data?: any;
  title?: ReactNode;
  subTitle?: ReactNode;
  loading?: boolean;
  iconType?: "danger" | "warning" | "success";
  children?: ReactNode;
  closeable?:boolean;
  handleClose: () => void;
  handleAction?: () => void;
  handleCancel?: () => void;
}

export default function ActionModal({
  title,
  iconType = "warning",
  subTitle,
  actionButton = true,
  actionBtnText = "Okay",
  actionBtnIcon,
  actionBtnIconType = "create",
  actionBtnType = "primary-light",
  cancelButton = true,
  cancelText = "Cancel",
  handleAction,
  handleCancel,
  handleClose,
  loading,
  children,
  closeable=false,
  ...rest
}: Props) {
  const ICONS = {
    danger: <AlertRedIcon />,
    warning: <AlertYellowIcon />,
    success: <SuccessGreenIcon />,
  };
  const ACTION_BUTTON_ICONS = {
    create: <AddIcon />,
    update: <EditIcon />,
    delete: <DeleteIcon />,
    refresh: <RefreshIcon />,
  };
  const ACTION_BUTTON_CLASSNAMES = {
    "danger-light": "button-danger-light h-10",
    "primary-light": "button-primary-light h-10",
    "bordered-light": "button-bordered-light h-10",
  };
  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={400}
        footer={null}
        closeIcon={closeable}
      >
        <div className="p-1 rounded flex items-center justify-center">
          {ICONS?.[iconType]}
        </div>

        <div className="text-[17px] font-semibold text-center mt-6">
          {title}
        </div>
        <div className="my-2 mt-3 text-[#5E718D] text-center mb-6">
          {subTitle}
        </div>
        {children}

        <div
          className={cn(
            "flex w-full mt-3",
            actionButton && cancelButton ? "justify-between" : "justify-center",
          )}
        >
          {cancelButton && (
            <Button
              onClick={() => (handleCancel ? handleCancel() : handleClose())}
              className="button-bordered-light h-10"
            >
              {cancelText}
            </Button>
          )}

          {actionButton && (
            <Button
              loading={loading}
              disabled={loading}
              onClick={() => handleAction && handleAction()}
              className={ACTION_BUTTON_CLASSNAMES?.[actionBtnType]}
            >
              {actionBtnIcon && ACTION_BUTTON_ICONS?.[actionBtnIconType]}{" "}
              {actionBtnText}
            </Button>
          )}
        </div>
      </CustomModal>
    </>
  );
}
